import { usePrivileges } from "@portal/hooks/use-privilleges";
import { useGetCustomFieldsBasedOnType } from "@portal/queries/custom-field-query";
import {
  CustomFieldTypes,
  CustomFieldColumData,
} from "@portal/types/entities/custom-field";
import {
  CustomFieldIconWithText,
  CustomFieldLables,
  GrowFlex,
  GrowTypography,
} from "@sinecycle/growcomponents";
import { useFormats } from "@portal/hooks/use-formats";
import { Skeleton } from "antd";
import { isEmpty } from "lodash";

interface CustomfieldDisplayProps {
  type: CustomFieldTypes;
  customFieldData?: CustomFieldColumData[];
  isLoading?: boolean;
}
const t = {
  otherDetail: "Other details",
  noData:'No data available'
};
const EmptyCustomField = <GrowTypography.Text style={{color:'var(--gray-7'}}>{t.noData}</GrowTypography.Text>;
function CustomfieldDisplay(props: CustomfieldDisplayProps) {
  const { getCFPrivileges } = usePrivileges();
  const { dateformat, locale } = useFormats();
  const { data: customFields, isLoading } = useGetCustomFieldsBasedOnType(
    props.type,
    () => {},
    getCFPrivileges("CUSTOM_FIELD_LIST_VIEW")
  );
  const CustomFieldsInfo = (
    <>
      {customFields?.map((field) => {
        const cfdata = props.customFieldData?.find((f) => f.cf_hash === field.id);
        const CustomFieldDisplayName = (
          <CustomFieldIconWithText
            style={{ fontSize: "var(--fs-12)", color: "var(--gray-7)" }}
          >
            {field.display_name}
          </CustomFieldIconWithText>
        );
        const CustomFieldData = (
          <>
            {cfdata ? (
              <CustomFieldLables
                dateFormat={dateformat}
                locale={locale}
                field={{
                  id: cfdata?.hash ,
                  data: {
                    type: field?.field_type,
                    value: cfdata?.value,
                  },
                }}
              />
            ) : (
              "-"
            )}
          </>
        );
        return (
          <GrowFlex vertical key={cfdata?.hash} space="4">
            {CustomFieldDisplayName} {CustomFieldData}
          </GrowFlex>
        );
      })}
    </>
  );
  const SelectContent = isEmpty(customFields) ? EmptyCustomField : CustomFieldsInfo;
  return (
    <GrowFlex vertical space={"16"}>
      <GrowTypography.Text strong>{t.otherDetail}</GrowTypography.Text>

      {isLoading ? <Skeleton.Input /> : SelectContent}
    </GrowFlex>
  );
}

export default CustomfieldDisplay;
